import { z } from "zod";

export const TaskInstanceSchema = z.object({
  id: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  workspaceId: z.string(),
  taskId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type TaskInstance = z.infer<typeof TaskInstanceSchema>;
